import React, { useState } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AccoCodeModal = ({ 
  open, 
  onClose, 
  reservation,
  onAccept,
  onDecline,
  isLoading
}) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        sx: { 
          borderRadius: "12px",
          overflow: "hidden"
        }
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          color: "#CD9D41",
          fontWeight: "bold",
          fontSize: "1.25rem",
          padding: "16px 24px",
          backgroundColor: "#f9f9f9"
        }}
      >
        Hochgeladener Gutschein
        <IconButton 
          onClick={onClose}
          sx={{
            "&:hover": {
              backgroundColor: "rgba(205, 157, 65, 0.1)"
            }
          }}
        >
          <CloseIcon sx={{ color: "#CD9D41" }} />
        </IconButton>
      </DialogTitle>

      <Divider sx={{ backgroundColor: "#CD9D41", height: "2px" }} />

      <DialogContent sx={{ py: 4, px: 3 }}>
        {reservation && (
          <>
            
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'center', 
              mb: 4,
              border: '1px solid #eee',
              borderRadius: '8px',
              padding: '16px'
            }}>
              <img 
                src={reservation.codePhoto} 
                alt="Gutschein" 
                style={{ 
                  width: '500px', 
                  height: '300px',
                  objectFit: "contain"
                }} 
              />
            </Box>

            <Box display="flex" justifyContent="end" gap={2}>
              <Button
                variant="contained"
                onClick={onDecline}
                disabled={isLoading}
                sx={{
                  backgroundColor: "#C03C3C",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#d6a6a6",
                  },
                  borderRadius: "8px",
                  px: 3,
                  py: 1,
                  fontSize: "0.875rem",
                  minWidth: "180px"
                }}
              >
                {isLoading ? "Wird bearbeitet..." : "Gutschein ablehnen"}
              </Button>
              
              <Button
                variant="contained"
                onClick={onAccept}
                disabled={isLoading}
                sx={{
                  backgroundColor: "#36D06A",
                  color: "#FFFFFF",
                  fontWeight: "bold",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#a6d6b1",
                  },
                  borderRadius: "8px",
                  px: 3,
                  py: 1,
                  fontSize: "0.875rem",
                  minWidth: "180px"
                }}
              >
                {isLoading ? "Wird bearbeitet..." : "Gutschein annehmen"}
              </Button>
            </Box>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default AccoCodeModal;